// Mock data service for deployed version
export const mockData = {
  // Dashboard data
  dashboard: {
    newSales: {
      thisWeek: 12,
      lastWeek: 8,
      thisMonth: 45,
      lastMonth: 38,
      totalValue: 125000,
      trend: 'up'
    },
    scheduledJobs: {
      today: 8,
      thisWeek: 24,
      nextWeek: 18,
      thisMonth: 85,
      urgent: 3,
      trend: 'up'
    },
    serviceRequests: {
      open: 15,
      inProgress: 8,
      completed: 42,
      urgent: 5,
      thisWeek: 12,
      trend: 'down'
    },
    messages: {
      unread: 12,
      today: 8,
      thisWeek: 35,
      urgent: 2,
      fromCustomers: 20,
      fromTeam: 15,
      trend: 'up'
    },
    customers: {
      totalCustomers: 125,
      activeCustomers: 98,
      prospectCustomers: 27,
      totalValue: 450000
    },
    installations: {
      totalInstallations: 65,
      completedInstallations: 42,
      inProgressInstallations: 8,
      scheduledInstallations: 15
    },
    schedules: {
      totalSchedules: 85,
      completedSchedules: 42,
      inProgressSchedules: 8,
      scheduledSchedules: 35
    },
    revenue: {
      thisMonth: 125000,
      lastMonth: 110000,
      thisYear: 1250000,
      trend: 'up'
    },
    services: {
      totalServiceRequests: 65,
      openServiceRequests: 15,
      inProgressServiceRequests: 8,
      completedServiceRequests: 42,
      cancelledServiceRequests: 0,
      averageResolutionTime: 2.5,
      averageCustomerSatisfaction: 4.8
    }
  },

  // Customers data
  customers: [
    {
      _id: '1',
      companyName: 'Smith Residence',
      contactPerson: {
        firstName: 'John',
        lastName: 'Smith',
        title: 'Homeowner'
      },
      email: 'john.smith@email.com',
      phone: '+1 (555) 123-4567',
      address: {
        street: '123 Main St',
        city: 'Denver',
        state: 'CO',
        zipCode: '80202',
        country: 'USA'
      },
      status: 'Proposal',
      customerType: 'residential',
      createdAt: '2024-01-15T10:30:00Z',
      lastContact: '2024-01-20T14:22:00Z',
      notes: 'Interested in full home lighting package',
      totalProjects: 1,
      totalValue: 2500,
      footage: 0,
      paymentAmount: 0,
      projects: [
        {
          _id: '1',
          name: 'Main House Lighting',
          description: 'Full home exterior lighting installation',
          status: 'quoted',
          priority: 'high',
          estimatedValue: 2500,
          startDate: '2024-02-01',
          endDate: '2024-02-05',
          estimatedDuration: 4,
          assignedTeam: [
            { id: '1', name: 'John Doe', role: 'Lead Installer' }
          ],
          materials: [],
          notes: 'Customer prefers warm white lights',
          location: 'Denver, CO',
          createdAt: '2024-01-15T10:30:00Z',
          updatedAt: '2024-01-20T14:22:00Z'
        }
      ]
    },
    {
      _id: '2',
      companyName: 'Johnson Family',
      contactPerson: {
        firstName: 'Sarah',
        lastName: 'Johnson',
        title: 'Homeowner'
      },
      email: 'sarah.johnson@email.com',
      phone: '+1 (555) 234-5678',
      address: {
        street: '456 Oak Ave',
        city: 'Boise',
        state: 'ID',
        zipCode: '83702',
        country: 'USA'
      },
      status: 'Scheduled',
      customerType: 'residential',
      createdAt: '2024-01-10T09:15:00Z',
      lastContact: '2024-01-25T11:45:00Z',
      notes: 'Scheduled for next week',
      totalProjects: 1,
      totalValue: 1800,
      footage: 0,
      paymentAmount: 0,
      projects: [
        {
          _id: '2',
          name: 'Holiday Lighting Setup',
          description: 'Holiday lighting installation and setup',
          status: 'in_progress',
          priority: 'medium',
          estimatedValue: 1800,
          startDate: '2024-02-10',
          endDate: '2024-02-12',
          estimatedDuration: 2,
          assignedTeam: [
            { id: '2', name: 'Jane Smith', role: 'Installer' }
          ],
          materials: [],
          notes: 'Scheduled for next week',
          location: 'Boise, ID',
          createdAt: '2024-01-10T09:15:00Z',
          updatedAt: '2024-01-25T11:45:00Z'
        }
      ]
    },
    {
      _id: '3',
      companyName: 'Brown Corporation',
      contactPerson: {
        firstName: 'Mike',
        lastName: 'Brown',
        title: 'Facilities Manager'
      },
      email: 'mike.brown@email.com',
      phone: '+1 (555) 345-6789',
      address: {
        street: '789 Pine St',
        city: 'Spokane',
        state: 'WA',
        zipCode: '99201',
        country: 'USA'
      },
      status: 'Installed',
      customerType: 'commercial',
      createdAt: '2024-01-05T14:20:00Z',
      lastContact: '2024-01-30T16:30:00Z',
      notes: 'Completed installation, follow up needed',
      totalProjects: 1,
      totalValue: 4500,
      footage: 0,
      paymentAmount: 0,
      projects: [
        {
          _id: '3',
          name: 'Office Building Lighting',
          description: 'Commercial office building exterior lighting',
          status: 'completed',
          priority: 'high',
          estimatedValue: 4500,
          startDate: '2024-01-15',
          endDate: '2024-01-18',
          estimatedDuration: 3,
          assignedTeam: [
            { id: '3', name: 'Mike Johnson', role: 'Lead Installer' }
          ],
          materials: [],
          notes: 'Completed installation, follow up needed',
          location: 'Spokane, WA',
          createdAt: '2024-01-05T14:20:00Z',
          updatedAt: '2024-01-30T16:30:00Z'
        }
      ]
    }
  ],

  // Installations data
  installations: [
    {
      _id: '1',
      customerId: '1',
      customerName: 'Smith Residence',
      type: 'install',
      status: 'scheduled',
      priority: 'high',
      location: 'Denver',
      scheduledDate: '2024-02-01',
      estimatedDuration: 4,
      technician: 'John Doe',
      description: 'Full home lighting installation',
      notes: 'Customer prefers warm white lights'
    },
    {
      _id: '2',
      customerId: '2',
      customerName: 'Johnson Family',
      type: 'service',
      status: 'in_progress',
      priority: 'medium',
      location: 'Boise',
      scheduledDate: '2024-01-30',
      estimatedDuration: 2,
      technician: 'Jane Smith',
      description: 'Holiday lighting maintenance',
      notes: 'Check all connections'
    }
  ],

  // Services data
  services: [
    {
      _id: '1',
      customerId: '1',
      customerName: 'Smith Residence',
      issue: 'Light not working',
      status: 'open',
      priority: 'high',
      reportedDate: '2024-01-25',
      assignedTo: 'John Doe',
      description: 'Front porch light stopped working',
      notes: 'Customer reported flickering before it stopped'
    },
    {
      _id: '2',
      customerId: '2',
      customerName: 'Johnson Family',
      issue: 'App connection problem',
      status: 'in_progress',
      priority: 'medium',
      reportedDate: '2024-01-20',
      assignedTo: 'Jane Smith',
      description: 'Cannot connect to WiFi app',
      notes: 'Router password changed'
    }
  ],

  // Scheduling data
  schedules: [
    {
      _id: '1',
      customerId: '1',
      customerName: 'Smith Residence',
      type: 'install',
      status: 'scheduled',
      priority: 'high',
      location: 'Denver',
      scheduledDate: '2024-02-01',
      timeSlot: '09:00',
      technician: 'John Doe',
      description: 'Full home lighting installation',
      notes: 'Customer prefers warm white lights'
    },
    {
      _id: '2',
      customerId: '2',
      customerName: 'Johnson Family',
      type: 'service',
      status: 'completed',
      priority: 'medium',
      location: 'Boise',
      scheduledDate: '2024-01-25',
      timeSlot: '14:00',
      technician: 'Jane Smith',
      description: 'Holiday lighting maintenance',
      notes: 'All lights working properly'
    }
  ],

  // Chat/Messages data
  messages: [
    {
      _id: '1',
      from: 'John Smith',
      fromType: 'customer',
      to: 'Support Team',
      subject: 'Installation Question',
      message: 'When will the installation be completed?',
      category: 'installation',
      priority: 'medium',
      status: 'unread',
      region: 'Denver',
      timestamp: '2024-01-25T10:30:00Z'
    },
    {
      _id: '2',
      from: 'Jane Smith',
      fromType: 'team',
      to: 'John Smith',
      subject: 'Installation Update',
      message: 'Installation will be completed by Friday',
      category: 'installation',
      priority: 'low',
      status: 'read',
      region: 'Denver',
      timestamp: '2024-01-25T11:00:00Z'
    }
  ],

  // Users/Settings data
  users: [
    {
      id: '1',
      firstName: 'Geo',
      lastName: 'Saldana',
      email: 'geo.saldana09@gmail.com',
      role: 'super_admin',
      status: 'active',
      lastLogin: '2024-03-15T16:30:00Z',
      createdAt: '2024-01-01T00:00:00Z',
      permissions: ['all_permissions']
    },
    {
      id: '2',
      firstName: 'John',
      lastName: 'Doe',
      email: 'john.doe@bosso.com',
      role: 'installer',
      status: 'active',
      lastLogin: '2024-01-25T09:00:00Z',
      createdAt: '2024-01-01T00:00:00Z',
      permissions: ['view_installs', 'update_install_status', 'view_schedule']
    },
    {
      id: '3',
      firstName: 'Jane',
      lastName: 'Smith',
      email: 'jane.smith@bosso.com',
      role: 'manager',
      status: 'active',
      lastLogin: '2024-01-25T08:30:00Z',
      createdAt: '2024-01-01T00:00:00Z',
      permissions: ['view_all', 'manage_team', 'view_reports', 'manage_schedule']
    }
  ]
};

// Mock API functions
export const mockApi = {
  // Authentication
  login: async (email: string, password: string) => {
    const user = mockData.users.find(u => u.email === email);
    if (!user || password !== 'Delta1196!') {
      throw new Error('Invalid email or password');
    }
    return {
      token: 'mock-jwt-token-' + Date.now(),
      user: user
    };
  },

  // Dashboard
  getDashboard: async () => {
    return mockData.dashboard;
  },

  // Customers
  getCustomers: async (filters: any = {}) => {
    let customers = [...mockData.customers];
    
    if (filters.search) {
      customers = customers.filter(customer => 
        customer.companyName.toLowerCase().includes(filters.search.toLowerCase()) ||
        `${customer.contactPerson.firstName} ${customer.contactPerson.lastName}`.toLowerCase().includes(filters.search.toLowerCase()) ||
        customer.email.toLowerCase().includes(filters.search.toLowerCase())
      );
    }
    
    if (filters.status) {
      customers = customers.filter(customer => customer.status === filters.status);
    }
    
    if (filters.customerType) {
      customers = customers.filter(customer => customer.customerType === filters.customerType);
    }
    
    return { customers };
  },

  // Installations
  getInstallations: async () => {
    return mockData.installations;
  },

  // Services
  getServices: async () => {
    return mockData.services;
  },

  // Scheduling
  getSchedules: async () => {
    return mockData.schedules;
  },

  // Messages/Chat
  getMessages: async () => {
    return mockData.messages;
  },

  // Users
  getUsers: async () => {
    return mockData.users;
  },

  // Create user
  createUser: async (userData: any) => {
    const newUser = {
      id: (mockData.users.length + 1).toString(),
      ...userData,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    mockData.users.push(newUser);
    return newUser;
  },

  // Update user
  updateUser: async (userId: string, userData: any) => {
    const userIndex = mockData.users.findIndex(u => u.id === userId);
    if (userIndex !== -1) {
      mockData.users[userIndex] = { ...mockData.users[userIndex], ...userData };
      return mockData.users[userIndex];
    }
    throw new Error('User not found');
  },

  // Delete user
  deleteUser: async (userId: string) => {
    const userIndex = mockData.users.findIndex(u => u.id === userId);
    if (userIndex !== -1) {
      mockData.users.splice(userIndex, 1);
      return { success: true };
    }
    throw new Error('User not found');
  },

  // Create schedule
  createSchedule: async (scheduleData: any) => {
    const newSchedule = {
      _id: (mockData.schedules.length + 1).toString(),
      ...scheduleData,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    mockData.schedules.push(newSchedule);
    return newSchedule;
  },

  // Delete schedule
  deleteSchedule: async (scheduleId: string) => {
    const scheduleIndex = mockData.schedules.findIndex(s => s._id === scheduleId);
    if (scheduleIndex !== -1) {
      mockData.schedules.splice(scheduleIndex, 1);
      return { success: true };
    }
    throw new Error('Schedule not found');
  },

  // Update customer
  updateCustomer: async (customerId: string, customerData: any) => {
    const customerIndex = mockData.customers.findIndex(c => c._id === customerId);
    if (customerIndex !== -1) {
      mockData.customers[customerIndex] = { ...mockData.customers[customerIndex], ...customerData };
      return mockData.customers[customerIndex];
    }
    throw new Error('Customer not found');
  },

  // Delete customer
  deleteCustomer: async (customerId: string) => {
    const customerIndex = mockData.customers.findIndex(c => c._id === customerId);
    if (customerIndex !== -1) {
      mockData.customers.splice(customerIndex, 1);
      return { success: true };
    }
    throw new Error('Customer not found');
  },

  // Save proposal draft
  saveProposalDraft: async (proposalData: any) => {
    // Mock saving proposal draft
    return { success: true, data: proposalData };
  },

  // Update customer data from proposal
  updateCustomerFromProposal: async (customerData: any) => {
    // Mock updating customer data
    return { success: true, data: customerData };
  },

  // Delete service request
  deleteServiceRequest: async (serviceId: string) => {
    const serviceIndex = mockData.services.findIndex(s => s._id === serviceId);
    if (serviceIndex !== -1) {
      mockData.services.splice(serviceIndex, 1);
      return { success: true };
    }
    throw new Error('Service request not found');
  },

  // Mark conversation as read
  markConversationRead: async (conversationId: string) => {
    // Mock marking conversation as read
    return { success: true };
  },

  // Send message
  sendMessage: async (conversationId: string, messageData: any) => {
    // Mock sending message
    return { success: true, data: messageData };
  }
};
